<template>
    <div class="popup-container" v-if="showPopup">
      <div class="popup">
        <div class="copy-container">
          <img alt="img" class="copyIcon" @click="handleNo" src="../assets/crossIcon.svg" />
        </div>
        <p class="message">{{ popupMessage }}</p>
        <div class="button-container">
          <button @click="handleYes">Continue</button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        showPopup: true,
        popupMessage: "Product count limit reached!You can add upto 50 products.Do you want to proceed?",
      };
    },
    methods: {
      closePopup() {
        this.showPopup = false;
      },
      handleYes() {
        this.closePopup();
        this.$emit('handleUserClick','yes');
      },
      handleNo() {
        this.closePopup();
        this.$emit('handleUserClick','no');
      },
    },
  };
  </script>
  
  <style scoped>
  .popup-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .popup {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    text-align: center;
  }
  
  .message {
    font-size: 18px;
    margin-bottom: 20px;
  }
  
  .button-container {
    display: flex;
    justify-content: center;
  }
  
  button {
    margin-left: 10px;
    padding: 10px;
    font-weight: bold;
    cursor: pointer;
    color: #fff;
    background-color: #2E31BE;
    border-color: #2E31BE;
    border-radius: 8px;
  }

  .copy-container{
    display: flex;
    justify-content: end;
  }

  .copyIcon{
    cursor: pointer;
  }

  </style>
  